const AppConfig = {
  api: {
    url: 'https://api.xosounion.com/api/'
  }
}

export default AppConfig;
